import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

class Alert extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        }
    }

    componentDidMount() {
        this.setState({
            alert: this.props.alert
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.alert != prevProps.alert &&
            this.props.alert != this.state.alert
        ) {
            this.setState({
                alert: this.props.alert
            })
        }
        
        if (
            this.state.alert.active &&
            this.state.alert.type == "succ"
        ) {
            this.handleDisapear();
        }
    }

    handleDisapear() {
        setTimeout(() => {
            this.setState({
                alert: {
                    active: false,
                    type: '',
                    title: '',
                    desc: ''
                }
            })
        }, 5000);
    }

    render() {
        return <div className={`alert ${this.state.alert.active && "alert--active"} alert--${this.state.alert.type}`}>
            <h2 className="alert__ttl">{this.state.alert.title}</h2>
            <p className="alert__desc">{this.state.alert.desc}</p>
            <button className="alert__btnclose" title="Fermer le message" aria-label="Fermer le message" onClick={() => this.setState({alert: {active: false, type: '', title: '', desc: ''}})}>
                <FontAwesomeIcon icon={faXmark} />
            </button>
        </div>
    }
}

export default Alert;